<!-- Layout -->
<app-layout></app-layout>
<ngx-loading-bar [includeBar]="false" [fixed]="false"></ngx-loading-bar>
